/* assets/cart-drawer-v2.js */
// -----------------------------Custom ATC FIX (START)---------------------------

(function () {
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function getV2Drawer() {
    return document.querySelector('cart-drawer.cart-drawer-v2');
  }

  function hasRealCartItems(drawer) {
    if (!drawer) return false;
    const rows = qsa('#CartDrawer-CartItems .cart-item', drawer);
    return rows.length > 0;
  }

  function syncV2DrawerState(drawer) {
    drawer = drawer || getV2Drawer();
    if (!drawer) return;

    const hasItems = hasRealCartItems(drawer);

    const emptyState = qs('.cdv2-empty-state', drawer);
    const scrollArea = qs('.cdv2-scroll-area', drawer);
    const stickyCheckout = qs('.cdv2-sticky-checkout', drawer);

    drawer.classList.toggle('is-empty', !hasItems);

    if (emptyState) emptyState.hidden = hasItems;
    if (scrollArea) scrollArea.hidden = !hasItems;
    if (stickyCheckout) stickyCheckout.hidden = !hasItems;
  }



  function bootV2Drawer() {
  syncV2DrawerState();

  if (typeof rxCleanupOrphans === 'function') {
    rxCleanupOrphans();
  }

  const drawer = getV2Drawer();



    if (!drawer) return;

    if (drawer.dataset.v2Observed === '1') return;
    drawer.dataset.v2Observed = '1';

    const mo = new MutationObserver(function () {
      syncV2DrawerState(drawer);
    });

    mo.observe(drawer, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', bootV2Drawer);
  document.addEventListener('cart:refresh', bootV2Drawer);

  window.SunhaukCartDrawerV2 = window.SunhaukCartDrawerV2 || {};
  window.SunhaukCartDrawerV2.sync = syncV2DrawerState;
  window.SunhaukCartDrawerV2.boot = bootV2Drawer;
})();
// -----------------------------Custom ATC FIX (END)---------------------------


// -----------------------------Drawer + Header Bubble Refresh Helpers (START)---------------------------
function updateSunhaukCartIconBubble(sectionHtml) {
  if (!sectionHtml) return false;

  var bubbleHost = document.getElementById('cart-icon-bubble');
  if (!bubbleHost) return false;

  var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');

  var newBubbleHost =
    doc.getElementById('cart-icon-bubble') ||
    doc.querySelector('#cart-icon-bubble');

  var newShopifySection = doc.querySelector('.shopify-section');

  if (newBubbleHost) {
    bubbleHost.innerHTML = newBubbleHost.innerHTML;
    return true;
  }

  if (newShopifySection) {
    bubbleHost.innerHTML = newShopifySection.innerHTML;
    return true;
  }

  var newCountBubble = doc.querySelector('.cart-count-bubble');
  var currentCountBubble = bubbleHost.querySelector('.cart-count-bubble');

  if (newCountBubble && currentCountBubble) {
    currentCountBubble.innerHTML = newCountBubble.innerHTML;
    return true;
  }

  if (newCountBubble && !currentCountBubble) {
    bubbleHost.insertAdjacentElement('beforeend', newCountBubble);
    return true;
  }

  if (!newCountBubble && currentCountBubble) {
    currentCountBubble.remove();
    return true;
  }

  return false;
}




function getSunhaukVisualCartCount(cart) {
  var count = 0;
  var protectionHandle = 'shipping-protection';
  // var mysteryHandle = 'mystery-polarized-pair';

  if (!cart || !cart.items) return count;

  cart.items.forEach(function(item) {
    var props = item.properties || {};
    var handle = item.handle || item.product_handle || '';

    var isShippingProtection = handle === protectionHandle;
    // var isMysteryPair = handle === mysteryHandle;
    var isRxAddon = props._rx_bundle && !props._rx_configured;

    if (!isShippingProtection  && !isRxAddon) {
      count += Number(item.quantity || 0);
    }
  });

  return count;
}



function forceUpdateSunhaukCartBubbleFromCart(cart) {
  var bubbleHost = document.getElementById('cart-icon-bubble');
  if (!bubbleHost || !cart) return;

  var visualCount = getSunhaukVisualCartCount(cart);
  var countBubble = bubbleHost.querySelector('.cart-count-bubble');

  if (visualCount <= 0) {
    if (countBubble) countBubble.remove();
    return;
  }

  if (!countBubble) {
    countBubble = document.createElement('div');
    countBubble.className = 'cart-count-bubble';
    bubbleHost.appendChild(countBubble);
  }

  countBubble.innerHTML = [
    visualCount < 100 ? '<span aria-hidden="true">' + visualCount + '</span>' : '',
    '<span class="visually-hidden">' + visualCount + ' items</span>'
  ].join('');
}

function forceSyncSunhaukCartBubble() {
  return fetch('/cart.js', {
    credentials: 'same-origin',
    headers: {
      'Accept': 'application/json'
    }
  })
    .then(function(r) {
      return r.json();
    })
    .then(function(cart) {
      forceUpdateSunhaukCartBubbleFromCart(cart);
      return cart;
    })
    .catch(function(error) {
      console.error('Header cart bubble force sync failed:', error);
    });
}


     // -------------------------------------------------------------Code added for the cart-page & cart-drawer sync (S)------------------------------------------------

function triggerSunhaukCartSync(source) {
  if (window.SunhaukCartSync && typeof window.SunhaukCartSync.refresh === 'function') {
    window.SunhaukCartSync.refresh({ source: source || 'cart-drawer-v2' });
    return;
  }

  document.dispatchEvent(
    new CustomEvent('sunhauk:cart:changed', {
      detail: {
        source: source || 'cart-drawer-v2'
      }
    })
  );
}
     // -------------------------------------------------------------Code added for the cart-page & cart-drawer sync (E)------------------------------------------------


function refreshCartDrawerAndBubble() {
  var drawer = document.querySelector('cart-drawer.cart-drawer-v2') || document.querySelector('cart-drawer');

  return fetch('/cart?sections=cart-drawer,cart-icon-bubble', {
    credentials: 'same-origin'
  })
    .then(function(r) {
      return r.json();
    })
    .then(function(data) {
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents({ sections: data });
      }

      updateSunhaukCartIconBubble(data['cart-icon-bubble']);

      if (
        window.SunhaukCartDrawerV2 &&
        typeof window.SunhaukCartDrawerV2.sync === 'function'
      ) {
        window.SunhaukCartDrawerV2.sync(drawer);
      }

      document.dispatchEvent(new CustomEvent('cart:updated'));


      /*
        Final safety sync:
        This is the important part for RX drawer removes.
        It makes the header bubble correct after parent + orphan cleanup.
      */
      return forceSyncSunhaukCartBubble();
    });
}
// -----------------------------Drawer + Header Bubble Refresh Helpers (END)---------------------------



 // ----------------------------------------------Upsell Carousel Logic (START)--------------------------------------------------

(function () {
  if (window.__SUNHAUK_CART_UPSELL_CAROUSEL_INIT__) return;

  window.__SUNHAUK_CART_UPSELL_CAROUSEL_INIT__ = true;


  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }


  function qsa(selector, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll(selector)
    );
  }



  /* ==========================================================
     Refresh cart drawer after an upsell is added
     ========================================================== */

  async function refreshUpsellDrawer(source) {

    const drawer =
      document.querySelector('cart-drawer.cart-drawer-v2') ||
      document.querySelector('cart-drawer');


    if (
      !drawer ||
      typeof drawer.renderContents !== 'function'
    ) {
      window.location.reload();
      return;
    }


    await refreshCartDrawerAndBubble();


    if (typeof rxCleanupOrphans === 'function') {
      await rxCleanupOrphans();
    }


    triggerSunhaukCartSync(
      source || 'cart-drawer-v2-upsell'
    );
  }



  /* ==========================================================
     Add currently selected upsell
     ========================================================== */

  async function addUpsellProduct(variantId) {

    const response = await fetch('/cart/add.js', {

      method: 'POST',

      credentials: 'same-origin',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })

    });


    if (!response.ok) {

      throw new Error(
        'Failed to add cart upsell product'
      );

    }


    return response.json();
  }



/* ==========================================================
   Find current/closest carousel card
   ========================================================== */

function getClosestUpsellSlideIndex(track, slides) {

  if (!track || !slides.length) {
    return 0;
  }


  const currentScroll =
    track.scrollLeft;


  let closestIndex = 0;
  let closestDistance = Infinity;


  slides.forEach(function (slide, index) {

    const distance =
      Math.abs(
        slide.offsetLeft -
        currentScroll
      );


    if (distance < closestDistance) {

      closestDistance = distance;
      closestIndex = index;

    }

  });


  return closestIndex;
}



/* ==========================================================
   Scroll cleanly to one card
   ========================================================== */

function scrollToUpsellSlide(
  track,
  slides,
  index
) {

  if (!track || !slides.length) {
    return;
  }


  index = Math.max(
    0,
    Math.min(
      index,
      slides.length - 1
    )
  );


  track.scrollTo({
    left: slides[index].offsetLeft,
    behavior: 'smooth'
  });

}



/* ==========================================================
   Desktop mouse dragging

   Important changes:
   - Very small swipe threshold
   - Drag distance amplified
   - One intentional swipe moves one card
   - No snap fighting while mouse is held down
   - Can grab almost anywhere on the card
   ========================================================== */

function bindDesktopDrag(track) {

  if (!track) return;


  if (
    track.dataset.desktopDragBound === '1'
  ) {
    return;
  }


  track.dataset.desktopDragBound = '1';


  let isDragging = false;

  let startX = 0;

  let lastX = 0;

  let startScrollLeft = 0;

  let startIndex = 0;

  let dragSlides = [];

  let hasMoved = false;



  track.addEventListener(
    'pointerdown',
    function (event) {

      /*
        Mobile/tablet continue using native touch swipe.
        This custom drag is desktop mouse only.
      */
      if (
        event.pointerType !== 'mouse' ||
        event.button !== 0
      ) {
        return;
      }


      /*
        Add button must remain a normal clickable button.
        Everywhere else on the card can initiate dragging.
      */
      if (
        event.target.closest(
          '[data-cdv2-upsell-add]'
        )
      ) {
        return;
      }


      dragSlides =
        qsa(
          '[data-cdv2-upsell-slide]',
          track
        );


      if (!dragSlides.length) {
        return;
      }


      isDragging = true;

      hasMoved = false;

      startX = event.clientX;

      lastX = event.clientX;

      startScrollLeft =
        track.scrollLeft;


      startIndex =
        getClosestUpsellSlideIndex(
          track,
          dragSlides
        );


      track.classList.add(
        'is-dragging'
      );


      /*
        Stops text/image selection making mouse dragging
        feel inconsistent.
      */
      event.preventDefault();


      try {

        track.setPointerCapture(
          event.pointerId
        );

      } catch (error) {
        // Safe browser fallback.
      }

    }
  );



  track.addEventListener(
    'pointermove',
    function (event) {

      if (!isDragging) return;


      lastX = event.clientX;


      const distance =
        event.clientX -
        startX;


      /*
        Tiny movement threshold.
        We don't wait for a large mouse movement.
      */
      if (
        Math.abs(distance) > 2
      ) {
        hasMoved = true;
      }


      if (!hasMoved) return;


      event.preventDefault();


      /*
        1.35 makes mouse drag more responsive.

        Example:
        user drags 50px
        carousel travels roughly 67px.
      */
      track.scrollLeft =
        startScrollLeft -
        (
          distance * 1.35
        );

    }
  );



  function finishDesktopDrag(
    event,
    cancelled
  ) {

    if (!isDragging) return;


    isDragging = false;


    const totalDistance =
      lastX -
      startX;


    track.classList.remove(
      'is-dragging'
    );


    try {

      if (
        track.hasPointerCapture(
          event.pointerId
        )
      ) {

        track.releasePointerCapture(
          event.pointerId
        );

      }

    } catch (error) {
      // Safe browser fallback.
    }


    if (!dragSlides.length) {
      return;
    }


    let targetIndex =
      getClosestUpsellSlideIndex(
        track,
        dragSlides
      );


    /*
      LOW-EFFORT SWIPE:

      Only about 24px of intentional mouse dragging
      is required to advance one card.

      Drag left = next card.
      Drag right = previous card.
    */
    if (
      !cancelled &&
      Math.abs(totalDistance) >= 24
    ) {

      if (totalDistance < 0) {

        targetIndex =
          startIndex + 1;

      } else {

        targetIndex =
          startIndex - 1;

      }

    }


    targetIndex = Math.max(
      0,
      Math.min(
        targetIndex,
        dragSlides.length - 1
      )
    );


    requestAnimationFrame(
      function () {

        scrollToUpsellSlide(
          track,
          dragSlides,
          targetIndex
        );

      }
    );

  }



  track.addEventListener(
    'pointerup',
    function (event) {

      finishDesktopDrag(
        event,
        false
      );

    }
  );



  track.addEventListener(
    'pointercancel',
    function (event) {

      finishDesktopDrag(
        event,
        true
      );

    }
  );



  /*
    Pointer capture normally handles leaving the element,
    but this keeps state clean in browsers that cancel it.
  */
  track.addEventListener(
    'lostpointercapture',
    function () {

      if (!isDragging) return;

      isDragging = false;

      track.classList.remove(
        'is-dragging'
      );

    }
  );



  /*
    Images should never trigger the browser's native
    image-drag ghost.
  */
  track.addEventListener(
    'dragstart',
    function (event) {

      event.preventDefault();

    }
  );

}



  /* ==========================================================
     Bind carousel
     ========================================================== */

  function bindUpsellCarousel(scope) {

    const wrap =
      qs(
        '[data-cdv2-upsell-carousel]',
        scope
      );


    if (!wrap) return;


    if (
      wrap.dataset.upsellCarouselBound === '1'
    ) {
      return;
    }


    wrap.dataset.upsellCarouselBound = '1';



    const track =
      qs(
        '[data-cdv2-upsell-track]',
        wrap
      );


    if (!track) return;



    /*
      Make horizontal dragging work on desktop.
    */
    bindDesktopDrag(track);



    /*
      Bind each upsell Add to Cart button.
    */
    const addButtons =
      qsa(
        '[data-cdv2-upsell-add]',
        wrap
      );


    addButtons.forEach(
      function (addButton) {

        addButton.addEventListener(
          'click',
          async function () {

            if (
              addButton.dataset.adding ===
              '1'
            ) {
              return;
            }


            const variantId =
              addButton.getAttribute(
                'data-variant-id'
              );


            if (!variantId) return;


            addButton.dataset.adding = '1';

            addButton.disabled = true;


            const originalText =
              addButton.textContent;


            addButton.textContent =
              'ADDING...';



            try {

              await addUpsellProduct(
                variantId
              );


              /*
                Full drawer refresh.

                The Liquid now automatically:
                - removes this product from upsells
                - keeps remaining products
                - removes whole carousel if none remain
              */
              await refreshUpsellDrawer(
                'cart-drawer-v2-upsell-add'
              );

            } catch (error) {

              console.error(
                'Cart drawer upsell add failed:',
                error
              );


              addButton.disabled = false;

              addButton.dataset.adding =
                '0';

              addButton.textContent =
                originalText;

            }

          }
        );

      }
    );

  }



  /* ==========================================================
     Initial setup + rebind after Dawn replaces drawer HTML
     ========================================================== */

  function initUpsellCarousel() {

    bindUpsellCarousel(document);


    const drawerRoot =
      document.querySelector(
        '.cart-drawer-v2'
      );


    if (!drawerRoot) return;


    if (
      drawerRoot.dataset
        .upsellCarouselObserved === '1'
    ) {
      return;
    }


    drawerRoot.dataset
      .upsellCarouselObserved = '1';



    const observer =
      new MutationObserver(
        function () {

          bindUpsellCarousel(
            document
          );

        }
      );


    observer.observe(
      drawerRoot,
      {
        childList: true,
        subtree: true
      }
    );

  }



  document.addEventListener(
    'DOMContentLoaded',
    initUpsellCarousel
  );

})();

// ------------------------------------------------Upsell Carousel Logic (END)-----------------------------------------------------





// -----------------------------Orphan Cleanup (START)---------------------------
function rxCleanupOrphans() {
  return fetch('/cart.js', {
    credentials: 'same-origin',
    headers: {
      'Accept': 'application/json'
    }
  })
    .then(function(r) {
      return r.json();
    })
    .then(function(cart) {
      var items = cart.items;
      if (!items || !items.length) {
        forceUpdateSunhaukCartBubbleFromCart(cart);
        return;
      }

      var parentBundles = {};

      items.forEach(function(item) {
        if (
          item.properties &&
          item.properties['_rx_bundle'] &&
          item.properties['_rx_configured'] === 'true'
        ) {
          parentBundles[item.properties['_rx_bundle']] = true;
        }
      });

      var updates = {};
      var hasOrphans = false;

      items.forEach(function(item) {
        if (
          item.properties &&
          item.properties['_rx_bundle'] &&
          item.properties['_rx_configured'] !== 'true'
        ) {
          if (!parentBundles[item.properties['_rx_bundle']]) {
            updates[item.key] = 0;
            hasOrphans = true;
          }
        }
      });

      /*
        No orphan add-ons left.
        Still force-sync the bubble because the drawer parent remove
        may have happened just before this function ran.
      */
      if (!hasOrphans) {
        forceUpdateSunhaukCartBubbleFromCart(cart);
        return cart;
      }

      /*
        Remove orphan RX add-ons.
        /cart/update.js returns the updated cart JSON.
        Use that response to update the header bubble immediately.
      */
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          updates: updates
        })
      })
        .then(function(r) {
          return r.json();
        })
        
     // -------------------------------------------------------------Code added for the cart-page & cart-drawer sync (S)------------------------------------------------

      .then(function(updatedCart) {
        forceUpdateSunhaukCartBubbleFromCart(updatedCart);

        return refreshCartDrawerAndBubble().then(function() {
        triggerSunhaukCartSync('cart-drawer-v2-rx-cleanup');
        return updatedCart;
        });
      });
     // -------------------------------------------------------------Code added for the cart-page & cart-drawer sync (E)------------------------------------------------

    })
    .catch(function(error) {
      console.error('RX orphan cleanup failed:', error);
    });
}
// -----------------------------Orphan Cleanup (END)---------------------------



